import { animated } from "@react-spring/web";
import classcat from "classcat";
import React from "react";

import { ConfirmationModal, IconTick } from "@touchtech/web-baselayer-ui";

import css from "./StyleNotExistModal.module.css";
import useManageStyleNotExistModal from "./hooks/useManageStyleNotExistModal";

type Props = {
  onClose: () => void;
};

const StyleNotExistModal = ({ onClose }: Props) => {
  const { handleCloseModal, styles, animatedRef, scannedValue, t } =
    useManageStyleNotExistModal({ onClose });

  return (
    <ConfirmationModal isOpen onClose={handleCloseModal}>
      <div className={css.modalContent}>
        <h1 className={classcat(["text-headline-5xl", css.title])}>
          {t("Please try again")}
        </h1>
        <span className={classcat(["text-label-xl", css.text])}>
          {`${t("No items were found with the code")} ${scannedValue}`}
        </span>

        <button
          ref={animatedRef}
          className={classcat(["text-button-xl text-white", css.okButton])}
          onClick={handleCloseModal}
        >
          <animated.div
            className={css.animatedButtonFill}
            style={styles}
          ></animated.div>
          <animated.div className={css.animatedButtonContent}>
            <IconTick />
            {t("OK")}
          </animated.div>
        </button>
      </div>
    </ConfirmationModal>
  );
};

export default StyleNotExistModal;
